/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_ChangePasswordPost } from '../models/Model_ChangePasswordPost';
import type { Model_ChangePasswordResult } from '../models/Model_ChangePasswordResult';
import type { Model_CreateResumeToken } from '../models/Model_CreateResumeToken';
import type { Model_LoginRequest } from '../models/Model_LoginRequest';
import type { Model_PublicLogin } from '../models/Model_PublicLogin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LoginService {
    /**
     * @param emailAddress
     * @returns Model_PublicLogin Success
     * @throws ApiError
     */
    public static getApiV1LoginEmailExists(
        emailAddress?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_PublicLogin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/login/emailExists',
            query: {
                'emailAddress': emailAddress,
            },
        });
    }
    /**
     * @param emailAddress
     * @param customerId
     * @returns any Success
     * @throws ApiError
     */
    public static postApiV1LoginSendloginRequestViaEmail(
        emailAddress?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/SendloginRequestViaEmail',
            query: {
                'emailAddress': emailAddress,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param emailAddress
     * @param requestId
     * @returns Model_LoginRequest Success
     * @throws ApiError
     */
    public static postApiV1LoginLoginRequestViaEmail(
        emailAddress?: ConvertDatesToStrings<string>,
        requestId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_LoginRequest> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/loginRequestViaEmail',
            query: {
                'emailAddress': emailAddress,
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @param passcode
     * @returns Model_CreateResumeToken Success
     * @throws ApiError
     */
    public static postApiV1LoginValidateRequest(
        requestId?: ConvertDatesToStrings<string>,
        passcode?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_CreateResumeToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/validateRequest',
            query: {
                'requestId': requestId,
                'passcode': passcode,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Model_ChangePasswordResult Success
     * @throws ApiError
     */
    public static postApiV1LoginChangePassword(
        requestBody?: ConvertDatesToStrings<Model_ChangePasswordPost>,
    ): CancelablePromise<Model_ChangePasswordResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/changePassword',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns Model_CreateResumeToken Success
     * @throws ApiError
     */
    public static postApiV1LoginDekoCustomerLoginOverride(
        id: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_CreateResumeToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/DEKOCustomerLoginOverride/{id}',
            path: {
                'id': id,
            },
        });
    }
}
